const ArticlesList = () => import('./components/ArticlesList')
const ArticlesManage = () => import('./components/ArticlesManage')

export default [
  {
    name: 'articles.index',
    path: '/articles',
    component: ArticlesList,
    meta: {
      hideNavbar: false,
      requiresAuth: true,
      permission: {
        context: 'articles',
        access: 'read'
      }
    }
  },
  {
    name: 'articles.manage',
    path: '/articles/manage/:id?',
    component: ArticlesManage,
    meta: {
      hideNavbar: false,
      requiresAuth: true,
      permission: {
        context: 'articles',
        access: 'write'
      }
    }
  }
]
